import React, { useEffect, useState, useRef } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { IoMdHeart } from "react-icons/io";
import { FaUser } from "react-icons/fa";
import { Link } from "react-router-dom";
import logo from "../assets/media/logo/ziya-&-ms-logo.png";
import { listLatestGoldPrice } from "../functions/PriceTag/GoldPrice";
import { listProspect } from "../functions/Prospect/Prsopect";
import LoginModal from "../pages/modal/loginModal";
import GoldPriceSection from "./GoldPriceSection";
const Header = () => {
  const [activeLink, setActiveLink] = useState(null);
  const [latestGoldPrice, setLatestGoldPrice] = useState("");
  const [userData, setUserData] = useState("");
  const [modalList, setModalList] = useState(false);
  const [openLogin, setOpenLogin] = useState(false);
  const handleHeartIconClick = () => {
    // Check if user is logged in
    if (userCheck) {
      
      window.location.href = "/whishlistnew";
    } else {
      setModalList(true);
      
    }
  };

  const [show, setShow] = useState(false);

  const tog_list = () => {
    setShow(!show);
    setModalList(true);
    // setValues(initialState);
  };

  const [userCheck, setuserCheck] = useState(false);
  let user = localStorage.getItem("RegisterUserID");

  useEffect(() => {
    loadGoldPrice();
    if (user) {
      setuserCheck(true);

    }
  }, []);

  useEffect(() => {
    if (user) {
      setuserCheck(true);
      listProspect()
        .then((res) => {
          try {
            
            
            let d = res.data;
            
            // Handle different response structures
            if (d && d.data && Array.isArray(d.data)) {
              d = d.data;
            } else if (!Array.isArray(d)) {
              d = [];
            }
            
            if (d && d.length > 0) {
              const checkData = d.find((l) => l && l._id === user);
              if (checkData && checkData.ContactPersonName) {
                setUserData(checkData.ContactPersonName);
              }
            }
          } catch (error) {
            console.error("Error processing prospect data:", error);
          }
        })
        .catch((err) => {
          console.error("Error fetching prospect data:", err);
        });
    }
  }, [user]);

  const loadGoldPrice = () => {
    listLatestGoldPrice()
      .then((res) => {

        if (res.data && res.data.GoldPrice) {
          setLatestGoldPrice(res.data.GoldPrice);
        }
      })
      .catch((err) => {
        console.error("Error fetching gold price:", err);
      });
  };
  const handleLogout = () => {
    localStorage.removeItem("RegisterUserID");
    setAccountOpen(false);
    // redirect to home after logout
    window.location.href = "/";
  };

  const handleLinkClick = (index) => {
    setActiveLink(index);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };
  const toggleAccount = () => {
    setAccountOpen(!accountOpen);
  };
  const accountRef = useRef(null);
  const accountToggleRef = useRef(null);

  // Close account dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(e) {
      if (accountOpen) {
        if (
          accountRef.current &&
          !accountRef.current.contains(e.target) &&
          accountToggleRef.current &&
          !accountToggleRef.current.contains(e.target)
        ) {
          setAccountOpen(false);
        }
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [accountOpen]);

  // Close dropdown when login modal opens
  useEffect(() => {
    if (modalList) setAccountOpen(false);
  }, [modalList]);
  return (
    <div>
      <div id="page" className="hfeed page-wrapper">
        <header id="site-header" className="site-header header-v2">
          <div className="header-mobile">
            <div className="section-padding">
              <div className="section-container large">
                <div className="row">
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-3 col-3 header-right d-flex">
                    <div className="navbar-header">
                      <button
                        className="hamberge-btn"
                        onClick={() => setIsOpen(!isOpen)}
                      >
                        ☰
                      </button>
                      <div className={`mobile-sidebar ${isOpen ? "open" : ""}`}>
                        <div className="sidebar-content">
                          <div className="d-flex justify-content-end">
                            <AiOutlineClose onClick={() => setIsOpen(false)} />
                          </div>
                          <ul>
                            <li>
                              <Link to="/" style={{ color: "white" }}>
                                HOME
                              </Link>
                            </li>
                            <li>
                              <Link to="/who-we-are" style={{ color: "white" }}>
                                WHO WE ARE
                              </Link>
                            </li>
                            <li>
                              <Link to="/ziya-experience" style={{ color: "white" }}>
                                THE ZIYA EXPERIENCE
                              </Link>
                            </li>
                            <li>
                              <Link to="/the-collection" style={{ color: "white" }}>
                                THE COLLECTION
                              </Link>
                            </li>
                            <li>
                              <Link to="/ziya-contact" style={{ color: "white" }}>
                                INQUIRY
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-6 header-center">
                    <div className="site-logo">
                      <Link to="/">
                        <img src={logo} alt="Ziya Jewellery" className="lgoMain" />
                      </Link>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-4 col-sm-3 col-3 d-flex align-items-center justify-content-end">
                    <div style={{ display: "flex", gap: "15px", alignItems: 'center' }}>
                      <Link to="#" className="menu-link" onClick={toggleAccount} ref={accountToggleRef}>
                        <span className="menu-item-text userIcon"><FaUser /></span>
                      </Link>
                      <Link to="#" className="menu-link" onClick={handleHeartIconClick}>
                        <span className="menu-item-text userIcon"><IoMdHeart /></span>
                      </Link>
                      {accountOpen && (
                        <div className="account-dropdown" ref={accountRef}>
                          {userCheck ? (
                            <>
                              <div
                                className="account-dropdown-item"
                                onClick={() => {
                                  setAccountOpen(false);
                                  window.location.href = "/my-account-new";
                                }}
                              >
                                {userData || "My Account"}
                              </div>
                              <div
                                className="account-dropdown-item"
                                onClick={() => {
                                  setAccountOpen(false);
                                  handleLogout();
                                }}
                              >
                                Logout
                              </div>
                            </>
                          ) : (
                            <>
                              <div
                                className="account-dropdown-item"
                                onClick={() => {
                                  setAccountOpen(false);
                                  setModalList(true);
                                }}
                              >
                                Login
                              </div>
                              <div
                                className="account-dropdown-item"
                                onClick={() => {
                                  setAccountOpen(false);
                                  window.location.href = "/partner-login";
                                }}
                              >
                                Partner Login
                              </div>
                            </>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      </div>
      {/* Login modal used by header */}
      <LoginModal modalList={modalList} setModalList={setModalList} />

      <div className="header-desktop">
        <div className="header-wrapper">
          <GoldPriceSection />
          <div className="section-padding">
            <div className="section-container large p-l-r">
              <div className="row justify-content-center">
                <div className="col-xl-10 col-lg-10 col-md-12 col-sm-12 col-12 header-center d-flex align-items-center justify-content-center" style={{ margin: "10px 0", gap: "130px" }}>
                  <div className="site-navigation left">
                    <nav id="main-navigation">
                      <ul id="menu-main-menu" className="menu d-flex">
                        <li className="level-0 menu-item" data-page="home"><Link to="/" className="menu-link"><span className="menu-item-text">Home</span></Link></li>
                        <li className="level-0 menu-item" data-page="who-we-are"><Link to="/who-we-are" className="menu-link"><span className="menu-item-text">Who we are</span></Link></li>
                        <li className="level-0 menu-item" data-page="ziya-experience"><Link to="/ziya-experience" className="menu-link"><span className="menu-item-text">The Ziya Experience</span></Link></li>
                      </ul>
                    </nav>
                  </div>
                  <div className="site-logo">
                    <Link to="/"><img src={logo} alt="Ziya Jewellery" className="lgoMain" /></Link>
                  </div>
                  <div className="site-navigation right">
                    <nav id="main-navigation">
                      <ul id="menu-main-menu" className="menu d-flex">
                        <li className="level-0 menu-item" data-page="the-collection" style={{ marginTop: "15px" }}><Link to="/the-collection" className="menu-link"><span className="menu-item-text">The Collection</span></Link></li>
                        <li className="level-0 menu-item" data-page="ziya-contact" style={{ marginTop: "15px" }}><Link to="/ziya-contact" className="menu-link"><span className="menu-item-text">INQUIRY</span></Link></li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
